import React from 'react';

const TelnyxIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="55"
    height="48"
    viewBox="0 0 55 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_5105_92229)">
      <path
        d="M27.5279 0.0664062L14.8051 22.4013H40.2399L27.5279 0.0664062ZM11.6298 30.388L0.5 47.933H22.7595V30.388H11.6298ZM32.2962 30.388H43.426L54.545 47.933H32.2962V30.388Z"
        fill="#31B886"
      />
    </g>
    <defs>
      <clipPath id="clip0_5105_92229">
        <rect width="54" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default TelnyxIcon;
